export default __webpack_public_path__ + "static/media/free-range-carton.120ee4bc.png";